import App from './App.svelte';
import About from './About.svelte';
import Games from './Games.svelte';

if(document.querySelector("#home")) {
  const app = new App({
    target: document.querySelector("#home"),
    props: {
    }
  });
} else if(document.querySelector("#about")) {
  const app = new About({
    target: document.querySelector("#about"),
  });
} else if(document.querySelector("#games")) {
  const app = new Games({
    target: document.querySelector("#games"),
  });
}

export default app;
